const initialstate = {
  products: [],
  productsLatest: [],
  product: {
    id: null,
    name: '',
    slug: '',
    description: '',
    price: null,
    mainImg: '',
    SubCategoryId: null,
    authorId: null,
    createdAt: '',
    updatedAt: '',
    SubCategory: {
      id: null,
      name: '',
      Category: {
        id: null,
        name: ''
      }
    },
    Images: []
  }
}

export default function productReducer(state = initialstate, action) {
  switch (action.type) {
    case 'products/fetchSuccess':
      return {
        ...state,
        products: action.payload
      }
    case 'productsLatest/fetchSuccess':
      return {
        ...state,
        productsLatest: action.payload
      }
    case 'product/fetchSuccess':
      return {
        ...state,
        product: action.payload
      }
    default:
      return state
  }
}

